import React from "react";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.css";
// -- Packages
import ReactDOM from "react-dom";
// -- Prime React
// -- Local
import { App } from "./App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
serviceWorker.unregister();
